/**
 * Clasificación comercial de usuarios — espejo frontend de bnt_platform/user_classification.py
 */

export const USER_TYPE_PLATAFORMA_BNT = "plataforma_bnt";
export const USER_TYPE_COMPRADOR_TITULAR = "comprador_titular";
export const USER_TYPE_COMPRADOR_DEMO = "comprador_demo";
export const USER_TYPE_AUXILIAR_DESPACHO = "auxiliar_despacho";
export const USER_TYPE_DISTRIBUIDOR = "distribuidor";
export const USER_TYPE_CUENTA_TECNICA = "cuenta_tecnica_prueba";
export const USER_TYPE_INCONSISTENTE = "inconsistente";

/** Emails que deben aparecer en Usuarios Administradores BNT (estado deseado actual). */
export const INTERNAL_BNT_EXPECTED_EMAILS = ["pruebas@bnt.local"];

/** Emails que no deben aparecer en Usuarios Administradores BNT. */
export const INTERNAL_BNT_EXCLUDED_EMAILS = [
  "despachobnt.mty@gmail.com",
  "bnt.contabilidad@gmail.com",
  "josebaldemar@designer-backdoor.local",
];

/**
 * @param {string} email
 * @returns {boolean}
 */
export function isExcludedFromInternalBntAdmins(email) {
  const em = String(email || "").trim().toLowerCase();
  if (INTERNAL_BNT_EXCLUDED_EMAILS.includes(em)) return true;
  if (em.endsWith("@designer-backdoor.local")) return true;
  return false;
}

/**
 * Filtra filas del listado interno BNT (defensa en profundidad tras API).
 * @param {Array<{ email?: string, role?: string, is_buyer_tenant?: boolean, tenant_buyer_id?: string }>} users
 */
export function filterInternalBntAdminUsers(users) {
  return (users || []).filter((u) => {
    const email = String(u.email || "").trim().toLowerCase();
    if (isExcludedFromInternalBntAdmins(email)) return false;
    if (u.is_buyer_tenant || u.tenant_buyer_id) return false;
    if (u.role === "buyer_admin") return false;
    if (u.is_admin_owner && u.role !== "platform_designer") return false;
    if (u.role === "user" || u.role === "consulta") return false;
    if (u.is_designer_backdoor) return false;
    if (u.role === "platform_designer" || u.role === "revendedor" || (u.role === "admin" && !u.is_admin_owner)) {
      if (u.role === "platform_designer" && email !== "pruebas@bnt.local") return false;
      return true;
    }
    return false;
  });
}
